import { render, staticRenderFns } from "./sql-test.vue?vue&type=template&id=277ae019&scoped=true"
import script from "./sql-test.vue?vue&type=script&lang=js"
export * from "./sql-test.vue?vue&type=script&lang=js"
import style0 from "./sql-test.vue?vue&type=style&index=0&id=277ae019&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277ae019",
  null
  
)

export default component.exports